import SiafLiteApiRepository from "../../external/siafLiteApi";

class MensagemPersonalizadaService {
  constructor() {
    this.urlBase = "/integracao/mensagem-personalizada";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  getById(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).getById(id);
  }

  getAll(filter) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filter);
  }

  cadastrar(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).post(body);
  }

  atualizar(id, body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).put(id, body);
  }

  deletar(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).delete(id);
  }

  getAllFiltroAvancado(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).patch(body);
  }

  getMensagem(body) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/mensagem`).patch(body);
  }

  enviarMensagemLote(body) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/mensagem-personalizada`
    ).patch(body);
  }

  getAllDestinatarios(id, body) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/destinatarios/${id}`
    ).patch(body);
  }
}

export default MensagemPersonalizadaService;
